import { render, staticRenderFns } from "./BookingConfirmed.vue?vue&type=template&id=77ae8ad3"
import script from "./BookingConfirmed.vue?vue&type=script&lang=js"
export * from "./BookingConfirmed.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmed.vue?vue&type=style&index=0&id=77ae8ad3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports